import { type BorrowMarketPathParams, getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

const borrowMarketQueryKey = ['borrowMarket'] as const

export function borrowMarketQueryOptions({ network, marketId }: BorrowMarketPathParams) {
  return queryOptions({
    queryKey: [...borrowMarketQueryKey, { network, marketId }] as const,
    async queryFn() {
      const internalAppSdk = getInternalAppSdk()
      return await internalAppSdk.getBorrowMarket({ network, marketId }).then((data) => data.market)
    },
    retry: 2,
    staleTime: 30 * MINUTE_IN_MILLISECONDS,
    refetchInterval: 30 * MINUTE_IN_MILLISECONDS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export function useBorrowMarketQuery({
  initialData,
  ...params
}: BorrowMarketPathParams & {
  initialData?: ReturnType<typeof borrowMarketQueryOptions>['initialData']
}) {
  const { data, isFetching } = useQuery({
    ...borrowMarketQueryOptions(params),
    initialData,
  })

  return { data, isFetching }
}
